/**
 * @file 全局新手引导
 * @author sunyingying01
 */

import React from 'react';
import {Modal} from 'antd';
import CloseSvg from '@assets/icons/close.svg';
import styles from './index.module.less';

interface GuideModalProps {
    visible: boolean;
    onClose: () => void;
}

const GuideModal: React.FC<GuideModalProps> = ({visible, onClose}) => {
    return (
        <Modal
            rootClassName={styles.guideModal}
            open={visible}
            onCancel={onClose}
            footer={null}
            width={1200}
            centered
            destroyOnHidden
            maskClosable={false}
            closeIcon={<CloseSvg />}
        >
            <div className={styles.modalContent}>
                <div className={styles.headerBg}>
                    <img src="https://now.bdstatic.com/stash/v1/84b278a/fm-console-fe/65c99cd/img/whitelist/image.png" alt="header background" />
                </div>
                <h2 className={styles.titleWrapper}>
                    <span className={styles.title}>欢迎使用</span>
                    <span className={styles.titleName}>百度伐谋</span>
                </h2>
                <p className={styles.subtitle}>
                    百度伐谋助力企业实现研发环节的智能原生和持续价值创造。系统具备自主演化能力，只需定义目标，伐谋即可自动探索、验证并持续优化方案。
                </p>

                <div className={styles.columns}>
                    {/* 左侧设置项 */}
                    <div className={styles.column}>
                        <div className={styles.imageWrapper}>
                            <img src="https://now.bdstatic.com/stash/v1/84b278a/fm-console-fe/65c99cd/img/whitelist/config.png" className={styles.img} alt="设定任务目标" />
                            <div className={styles.textOverlay}>
                                <h3 className={styles.overlayTitle}>设定任务目标</h3>
                                <p className={styles.overlayDesc}>
                                    通过界面或配置文件，明确优化目标、输入变量、约束条件及评估方式。
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 中间流程图 */}
                    <div className={styles.column}>
                        <div className={styles.imageWrapper}>
                            <img src="https://now.bdstatic.com/stash/v1/84b278a/fm-console-fe/65c99cd/img/whitelist/data.png" className={styles.img} alt="开始迭代演化" />
                            <div className={styles.textOverlay}>
                                <h3 className={styles.overlayTitle}>开始迭代演化</h3>
                                <p className={styles.overlayDesc}>
                                    系统自动开启演化进程，持续探索并生成更优方案。可实时观测演化状态与趋势，并进行干预。
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 右侧结果图 */}
                    <div className={styles.column}>
                        <div className={styles.imageWrapper}>
                            <img src="https://now.bdstatic.com/stash/v1/84b278a/fm-console-fe/65c99cd/img/whitelist/result.png" className={styles.img} alt="得出优化结果" />
                            <div className={`${styles.textOverlay} ${styles.resultOverlay}`}>
                                <h3 className={styles.overlayTitle}>得出优化结果</h3>
                                <p className={styles.overlayDesc}>
                                    直观呈现优化结果，助力快速理解方案价值并落地应用。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.footer}>
                    <img src="https://now.bdstatic.com/stash/v1/84b278a/fm-console-fe/65c99cd/img/whitelist/start.png" alt="开始使用" className={styles.startBtn} onClick={onClose} />
                </div>
            </div>
        </Modal>
    );
};

export default GuideModal;
